<template>
  <div class="h-100">
    <div class="content-page pr-3 pl-3 pt-2 pb-2 h-100">
      <div class="row h-100">
        <div class="col-4 h-100">
          <div class="h-100 bg-white">
            <div
              class="tab-pane active table-responsive color-table h-85"
              id="event"
            >
              <b-table
                :items="eventTableDataList"
                :fields="fieldsOutdoor"
                :current-page="pageOutdoor"
                :per-page="15"
              >
                <template #head(Action)>
                  <font-awesome-icon
                    icon="plus"
                    style="cursor: pointer"
                    @click="initEvent"
                  />
                </template>
                <template #cell(Action)="data">
                  <div class="float-right">
                    <font-awesome-icon
                      icon="edit"
                      style="cursor: pointer"
                      color="#337ab7"
                      @click="getOutdoorworkById(data.item.EventCode)"
                    />
                  </div>
                </template>
              </b-table>
            </div>
            <b-row no-gutters class="pt-3" v-if="eventTableDataList.length > 0">
              <b-col cols="2">
                <b-pagination
                  limit="10"
                  v-model="pageOutdoor"
                  :per-page="15"
                  :total-rows="eventTableDataList.length"
                ></b-pagination>
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="col-8 h-100">
          <div class="h-100 bg-white font-weight-bold">
            <div class="tab-pane active table-responsive color-table h-90">
              <div
                class="row table2_header"
                style="margin: 0; height: 34px; padding: 3px"
              >
                <div class="col-sm-5 pt-0 pb-0 pr-0 pl-0">
                  <b-form-input
                    v-model="event.EngEventTitle"
                    :placeholder="this.t.t(dictEnum.LBL_Event)"
                    maxlength="50"
                    style="height: 27px"
                  ></b-form-input>
                </div>
              </div>
              <div>
                <div class="col-lg-12 pr-4 pl-4 pt-0 pb-0">
                  <div>
                    <b-row class="my-1 no-gutters">
                      <b-col sm="3">
                        <label for="local">
                          {{ this.t.t(dictEnum.LBL_Type) }}
                        </label>
                      </b-col>
                      <b-col sm="3">
                        <b-form-group class="font-weight-normal">
                          <b-form-radio-group id="local" v-model="event.Local">
                            <b-form-radio name="some-radios" value="Local">
                              {{ this.t.t(dictEnum.LBL_Local) }}
                            </b-form-radio>
                            <b-form-radio name="some-radios" value="Oversea">
                              {{ this.t.t(dictEnum.LBL_Oversea) }}
                            </b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row class="my-1 no-gutters">
                      <b-col sm="3">
                        <label for="eventDesc">
                          {{ this.t.t(dictEnum.LBL_Description) }}:
                        </label>
                      </b-col>
                      <b-col id="eventDesc" sm="9">
                        <b-form-input
                          maxlength="50"
                          v-model="event.EventDesc"
                          size="sm"
                        ></b-form-input>
                      </b-col>
                    </b-row>

                    <b-row class="my-1 no-gutters">
                      <b-col sm="3">
                        <label for="eventLoc">
                          {{ this.t.t(dictEnum.LBL_Location) }}:
                        </label>
                      </b-col>
                      <b-col sm="9">
                        <b-form-input
                          maxlength="100"
                          v-model="event.EventLoc"
                          size="sm"
                        ></b-form-input>
                      </b-col>
                    </b-row>

                    <b-row class="my-1 no-gutters">
                      <b-col sm="3">
                        <label for="eventLoc">
                          {{ this.t.t(dictEnum.LBL_WorkType) }}:
                        </label>
                      </b-col>
                      <b-col sm="3">
                        <b-form-select
                          v-model="event.WorkType"
                          :options="workTypeList"
                          value-field="WorkType"
                          size="sm"
                          :text-field="user.Lang == 'EN' ? 'EDesc' : 'CDesc'"
                        ></b-form-select>
                      </b-col>
                    </b-row>

                    <b-row class="my-1 no-gutters">
                      <b-col sm="3">
                        <label for="eventLoc">
                          {{ this.t.t(dictEnum.LBL_Time) }}:
                        </label>
                      </b-col>
                      <b-col sm="3" class="mr-2">
                        <b-form-input
                          type="time"
                          v-model="event.FromTime"
                          locale="en"
                        ></b-form-input>
                      </b-col>
                      <b-col sm="3">
                        <b-form-input
                          type="time"
                          v-model="event.ToTime"
                          locale="en"
                        ></b-form-input>
                      </b-col>
                    </b-row>

                    <b-row class="my-1 no-gutters">
                      <b-col sm="3">
                        <label for="dateRangePicker">
                          {{ this.t.t(dictEnum.LBL_Date) }}:
                        </label>
                      </b-col>
                      <b-col sm="9">
                        <m-date-picker
                          class="pick-panel-date"
                          v-model="event.EventDates"
                          multi
                          lang="en"
                        ></m-date-picker>
                      </b-col>
                    </b-row>

                    <b-row class="my-1 no-gutters">
                      <b-col sm="3">
                        <label for="supervisor">
                          {{ this.t.t(dictEnum.LBL_Supervisor) }}:
                        </label>
                      </b-col>
                      <b-col sm="3">
                        <b-form-select
                          id="supervisor"
                          v-model="event.SupervisorID"
                          size="sm"
                        >
                          <option
                            v-for="(supervisor,
                            supervisorIndex) in staffTableDataList"
                            :key="supervisorIndex"
                            :value="supervisor.StaffID"
                          >
                            {{
                              user.Lang == "EN"
                                ? `${supervisor.EngName} ${
                                    supervisor.EngLastName
                                  }`
                                : `${supervisor.ChiLastName}${
                                    supervisor.ChiName
                                  }`
                            }}
                          </option>
                        </b-form-select>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col sm="12" class="color-table">
                        <b-table
                          :items="staffTableDataList"
                          :fields="staffFields"
                          :current-page="currentPageStaff"
                          :per-page="10"
                        >
                          <template #cell(EngName)="data">
                            {{
                              user.Lang == "EN"
                                ? `${data.item.EngName} ${
                                    data.item.EngLastName
                                  }`
                                : `${data.item.ChiLastName}${data.item.ChiName}`
                            }}
                          </template>
                          <template #cell(Action)="data">
                            <div class="float-right">
                              <div class="row">
                                <div class="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    :id="`chkBox${data.item.StaffID}`"
                                    v-model="event.UsersList"
                                    :v-id="data.item.StaffID"
                                    :value="data.item.StaffID"
                                  />
                                  <label
                                    class="custom-control-label text-white"
                                    :for="`chkBox${data.item.StaffID}`"
                                  ></label>
                                </div>
                              </div>
                            </div>
                          </template>
                        </b-table>
                      </b-col>
                    </b-row>
                    <b-row
                      no-gutters
                      class="pt-3"
                      v-if="staffTableDataList.length > 0"
                    >
                      <b-col cols="2">
                        <b-pagination
                          limit="10"
                          v-model="currentPageStaff"
                          :per-page="10"
                          :total-rows="staffTableDataList.length"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </div>
            <div class="h-10 p-2">
              <b-row>
                <b-col sm="12" class="text-right">
                  <button
                    v-if="hasRight(Settings.Permission.Change) && event.EventCode"
                    type="button"
                    class="btn btn-danger"
                    @click="deleteEvent"
                  >
                    {{ this.t.t(dictEnum.BTN_Delete) }}
                  </button>

                  <button
                    v-if="hasRight('AlwDel') && event.EventCode"
                    type="button"
                    class="btn btn-success"
                    @click="finishEvent"
                  >
                    {{ this.t.t(dictEnum.BTN_Finish) }}
                  </button>

                  <button
                    v-if="hasRight('AlwWrite')"
                    type="button"
                    class="btn btn-info"
                    @click="addOrUpdateEvent"
                  >
                    {{
                      this.event.EventCode
                        ? this.t.t(dictEnum.BTN_Update)
                        : this.t.t(dictEnum.LBL_Add)
                    }}
                  </button>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import mDatePicker from "@/components/multiDatePicker/multiDatePicker.vue";
import MenuRightSerivce from "@/service/MenuRightService";
import OutdoorworkService from "@/service/OutdoorworkService";
import HandleErrorService from "@/service/HandleErrorService";
import UserService from "@/service/UserService";
import WorkTypeService from "@/service/WorkTypeService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { Event } from "@/model/Event";
import Settings from "../constants/Settings";
const calendar = DatePicker.components.CalendarPanel;

export default {
  components: {
    DatePicker,
    mDatePicker,
    moment
  },
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    t() {
      return t;
    }
  },
  data() {
    return {
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      Settings: Settings,
      menuId: Settings.MenuID.OutdoorWork,
      workTypeList: [],
      dictEnum: dictEnum,
      staffTableColumns: ["EngName", "JobTitle", "Action"],
      staffTableDataList: [],
      staffTableOptions: {
        filterable: false,
        sortable: [],
        perPageValues: [],

        skin: "table table-hover v-midle",
        headings: {
          EngName: "EngName",
          JobTitle: "JobTitle",
          Action: "Action"
        },
        texts: {},
        columnsClasses: {}
      },
      eventTableDataList: [],
      eventColumns: ["EventCode", "EventDesc", "Action"],
      event: new Event(),
      eventOptions: {
        filterable: false,
        sortable: [],
        perPageValues: [],
        skin: "table table-hover v-midle",
        headings: {
          EngName: "Event",
          EventDesc: "EventDesc",
          Action: "Action"
        },
        texts: {},
        columnsClasses: {}
      },
      pageOutdoor: 1,
      fieldsOutdoor: [
        {
          key: "EventCode",
          label: t.t(dictEnum.LBL_Event)
        },
        {
          key: "EventDesc",
          label: t.t(dictEnum.LBL_Description)
        },
        {
          key: "Action",
          label: t.t(dictEnum.LBL_Action)
        }
      ],
      currentPageStaff: 1,
      staffFields: [
        {
          key: "EngName",
          label: t.t(dictEnum.LBL_StaffName)
        },
        {
          key: "JobTitle",
          label: t.t(dictEnum.LBL_JobTitle)
        },
        {
          key: "Action",
          label: t.t(dictEnum.LBL_Action)
        }
      ]
    };
  },

  methods: {
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];

      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async deleteEvent(id) {
      const obj = {
        eventCode: this.event.EventCode
      };

      const response = await OutdoorworkService.deleteOutdoorwork(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success(response.data.Message);
        this.getAllEvent();
      } else {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.LBL_Event) + this.t.t(dictEnum.WARN_IsDeleted)
        );
      }
    },

    async finishEvent(id) {
      const obj = {
        UserID: this.$store.getters[StoreGetter.user].UserID,
        eventCode: this.event.EventCode
      };
      const response = await OutdoorworkService.finishOutdoorwork(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success(response.data.Message);
        this.getAllEvent();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllEvent() {
      const response = await OutdoorworkService.getOutdoorworks();
      if (response.data.IsSuccess) {
        this.eventTableDataList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getuser() {
      const obj = {};
      try {
        const response = await UserService.getUsers(obj);
        if (!response.data.IsSuccess) {
          SweetAlertService.warning("Warn", response.data.Message);
        } else {
        }
      } catch (e) {
        HandleErrorService.handleError(e, this.hideLoader);
      }
    },
    async getworktype() {
      try {
        const response = await WorkTypeService.getWorkTypes();
        if (!response.data.IsSuccess) {
          SweetAlertService.warning("Warn", response.data.Message);
        } else {
          this.workTypeList = response.data.Data;
        }
      } catch (e) {
        HandleErrorService.handleError(e, this.hideLoader);
      }
    },
    initEvent() {
      this.event = new Event();
      this.event.EventDates = [];
      this.event.UsersList = [];
    },

    async getOutdoorworkById(EventCode) {
      const obj = {
        eventCode: EventCode
      };
      const res = await OutdoorworkService.getOutdoorworkById(obj);
      if (res.data.IsSuccess) {
        let data = res.data.Data;
        data.EventDates = data.EventDates.split(",").map(x => new Date(x));
        data.Local = res.data.Data.Local ? "Local" : "Oversea";
        this.event = data;
      } else {
        SweetAlertService.warning("Warn", res.data.Message);
      }
    },

    frontEndDateFormat: function(date) {
      return moment(date, Settings.DateTime.yyyymmdd).format("DD/MM/YYYY");
    },
    async addOrUpdateEvent() {
      if (!this.event.EventCode) {
        this.addOrUpdateEventApiCall();
      } else {
        const sweetAlertOptions = {
          title: this.t.t(dictEnum.WARN_Confirm),
          text: this.t.t(dictEnum.WARN_UpdateEvent),
          cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
          confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
        };
        const result = await SweetAlertService.question(sweetAlertOptions);
        if (result.value) {
          await this.addOrUpdateEventApiCall();
        }
      }
    },
    async addOrUpdateEventApiCall() {
      const formatEventDates = [];

      if (!this.event.SupervisorID) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.LBL_Supervisor) + this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (!this.event.EventDesc) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.LBL_EventEngTitle) +
            this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (!this.event.WorkType) {
        SweetAlertService.warning("Warn", this.t.t(dictEnum.WARN_Type));
        return;
      }

      if (!this.event.EventDesc) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.LBL_Description) +
            this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      if (!this.event.EventLoc) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.LBL_Location) + this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (!this.event.WorkType) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.LBL_WorkType) + this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (!this.event.FromTime) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.LBL_From) + this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (!this.event.ToTime) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.LBL_To) + this.t.t(dictEnum.WARN_IsRequired)
        );

        return;
      }

      if (this.event.ToTime < this.event.FromTime) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(this.dictEnum.WARN_FromTimeCannotGreaterThanToTime)
        );
        return;
      }

      if (!this.event.EventDates) {
        SweetAlertService.warning("Warn", this.t.t(dictEnum.WARN_Date));
        return;
      }

      if (this.event.EventDates.length > 9) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.WARN_MaxOutdoorworkDays)
        );
        return;
      }

      if (this.event.EventDates.length > 0) {
        for (let i = 0; i <= this.event.EventDates.length; i++) {
          const numberofmultidate = moment(this.event.EventDates[i]).format(
            Settings.DateTime.yyyymmdd
          );
          formatEventDates.push(numberofmultidate);
        }
        formatEventDates.pop();
      }
      if (this.event.UsersList.length == 0) {
        SweetAlertService.warning("Warn", this.t.t(dictEnum.WARN_Staff));
        return;
      }

      const obj = {
        EventTitle: this.event.EngEventTitle,
        EngEventTitle: this.event.EngEventTitle,
        ChiEventTitle: this.event.EngEventTitle,
        EventCode: this.event.EventCode,
        EventDesc: this.event.EventDesc,
        EventLoc: this.event.EventLoc,
        WorkType: this.event.WorkType,
        SupervisorID: this.event.SupervisorID,
        Local: this.event.Local === "Local" ? true : false,
        FromTime: this.event.FromTime,
        ToTime: this.event.ToTime,
        EventDates: formatEventDates.toString(),
        AddBy: this.$store.getters[StoreGetter.user].UserID,
        UsersList: this.event.UsersList
      };

      const res = this.event.EventCode
        ? await OutdoorworkService.modifyOutdoorwork(obj)
        : await OutdoorworkService.addOutdoorwork(obj);
      if (res.data.IsSuccess) {
        SweetAlertService.success(res.data.Message);
        this.getAllEvent();
        this.event = new Event();
      } else {
        SweetAlertService.warning("Warn", res.data.Message);
        this.event = new Event();
      }
    },
    async getuserlist() {
      try {
        const obj = {};
        const response = await UserService.getUsers(obj);
        if (!response.data.IsSuccess) {
          SweetAlertService.warning("Warn", response.data.Message);
        } else {
          this.staffTableDataList = response.data.Data;
        }
      } catch (e) {
        HandleErrorService.handleError(e, this.hideLoader);
      }
    }
  },

  mounted() {
    this.assignRights();

    var data = this.$store.getters[StoreGetter.user];
    this.session_user_id = data.UserID;

    this.getAllEvent();
    this.getuser();
    this.getworktype();
    this.getuserlist();

    this.eventOptions = {
      filterable: false,
      sortable: [],
      perPageValues: [],
      skin: "table table-hover v-midle",
      headings: {
        EventCode: this.t.t(dictEnum.LBL_Event),
        EventDesc: this.t.t(dictEnum.LBL_Description),
        Action: this.t.t(dictEnum.LBL_Action)
      },
      texts: {
        noResults: this.t.t(dictEnum.LBL_NoData),
        count: ``
      },
      columnsClasses: {}
    };

    this.staffTableOptions = {
      filterable: false,
      sortable: [],
      perPageValues: [],
      skin: "table table-hover v-midle",
      headings: {
        EngName: this.t.t(dictEnum.LBL_StaffName),
        JobTitle: this.t.t(dictEnum.LBL_JobTitle),
        UpdateAction: this.t.t(dictEnum.LBL_Action)
      },
      texts: {
        filterPlaceholder: this.t.t(dictEnum.LBL_SearchQuery),
        noResults: this.t.t(dictEnum.LBL_NoData),
        count: ``
      },
      columnsClasses: {}
    };
  }
};
</script>

<style scoped lang="scss">
.mx-datepicker {
  position: relative;
  display: inline-block;
  width: 122px;
  color: #73879c;
  font: 14px/1.5 "Helvetica Neue", Helvetica, Arial, "Microsoft Yahei",
    sans-serif;
}

.pick-panel-date {
  /* width: 200px !important;
  display: block;
  margin: 14px -55px !important; */
  padding: 0;
}

.pick-panel {
  width: 315px !important;
}

.radio input[type="radio"] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
  width: 18px;
  height: 18px;
}

.checkbox input[type="checkbox"] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
  width: 18px;
  height: 18px;
  margin-top: inherit;
}
div#event table tr th + th + th {
  width: 100px;
}

.mx-input-append .mx-calendar-icon {
  background-image: url();
  background-position: 50%;
  background-repeat: no-repeat;
}
input#Overseals,
input#Local {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
  width: 20px !important;
  height: 24px !important;
}

>>> .b-form-time-control button {
  padding: 0 !important;
}

>>> .bi-circle-fill {
  height: 0.5em;
  width: 0.5em;
}

>>> .selected-date {
  max-width: 100% !important;
}
>>> .VuePagination__pagination {
  margin: 0px;
}

>>> .VuePagination__count {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/S010100-Outdoorwork.vue